import { AccountMultipleCheckOutlineIcon } from './AccountMultipleCheckOutlineIcon';

/**
 * author: Michael Richins
 * id 4391B451-368F-4E41-82C5-63A89A2CDE69
 * name account-multiple-check-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-check-outline.svg
 * tags
 * - Account / User 
 */
export const AccountsCheckOutlineIcon = AccountMultipleCheckOutlineIcon;
export default AccountsCheckOutlineIcon